import Modal from './Modal'
export default Modal

export {default as PaymentModal} from './PaymentModal'
export {default as WelcomeModal} from './WelcomeModal'
export {default as UpgradeModal} from './UpgradeModal'



// WEBPACK FOOTER //
// ./src/component/Modal/index.js